// extracted by mini-css-extract-plugin
module.exports = {"date":"ProcedureTableInfo_date__2CyoJ","head":"ProcedureTableInfo_head__1zmTM"};